<div class="validate-subscription-page">
  <app-loader [size]="'very-big'"></app-loader>
</div>
